import { lazy } from "react";

const Expenses = lazy(() => import("./expenses"));
const Suppliers = lazy(() => import("./Suppliers"));
const ContactForm = lazy(() => import("../Customers&Leads/ContactEditor2"));

const ExpensesRoutes = [
  {
    path: "/expenses/expense",
    element: <Expenses />,
  },
  {
    path: "/expenses/Suppliers",
    element: <Suppliers />,
  },
  {
    path: "/expenses/suppliers/new",
    element: <ContactForm />,
  },
  {
    path: "/expenses/suppliers/edit/:id",
    element: <ContactForm />,
  },
  {
    path: "/addFournisseur",
    element: <ContactForm />,
  },
];

export default ExpensesRoutes;
